import { Component, OnInit } from '@angular/core'
import { AuthService } from '../../services/auth.services'

@Component({
    selector: 'app-faq',
    templateUrl: './faq.component.html',
    styleUrls: ['../promotion.component.css'],
})
export class FaqComponent implements OnInit {

    en = {}
    showEN = true

    constructor(private auth: AuthService) {
    }

    ngOnInit() {
    }

    changeLanguage() {
        return this.en = this.auth.showLang(this.showEN)
    }
}



// WEBPACK FOOTER //
// ./src/app/promotion/faq/faq.component.ts